import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { loginPathFor } from '@shared/v2Redirect'

// Guarda das rotas da conta V2: sem sessão, leva à tela de login V2 da conta
// (o PrivateRoute V1 manda para "/", que derruba o usuário na home), levando o
// destino em ?redirect_to= para voltar a ele depois do login.
export default function V2PrivateRoute({ component: Component }) {
  const location = useLocation()
  const authenticated = useSelector(state => state.sessionReducer && state.sessionReducer.authenticated)
  return authenticated ? (
    <Component />
  ) : (
    <Navigate to={loginPathFor(location.pathname, location.search, location.hash)} replace />
  )
}
